/*
 *
 * Home actions
 *
 */

import * as Types from "./constants";

export function showSuccess(payload) {
  return {
    type: Types.TOAST_SUCCESS,
    payload: payload,
  };
}

export function showError(payload) {
  return {
    type: Types.TOAST_ERROR,
    payload: payload,
  };
}

export function getSchoolDetail(params) {
  return {
    type: Types.GET_SCHOOL_DETAIL_REQUESTED,
    payload: params,
  };
}

export function setBestActivity(activities) {
  return {
    type: Types.SET_BEST_ACTIVITIES,
    payload: activities,
  };
}

export function setHasMore(boolean) {
  return {
    type: Types.SET_HAS_MORE_BEST_ACTIVITIES,
    payload: boolean,
  };
}

export function getAddAbleMemberList(searchString) {
  return {
    type: Types.GET_ADD_ABLE_MEMBER_LIST_REQUESTED,
    payload: searchString,
  };
}

export function getBestActivitiesList(payload) {
  return {
    type: Types.GET_BEST_ACTIVITIES_LIST_REQUESTED,
    payload,
  };
}

export function getAvailableRoleList(schoolSlug) {
  return {
    type: Types.GET_AVAILABLE_ROLE_LIST_REQUESTED,
    payload: schoolSlug,
  };
}

export function submitUser(data) {
  return {
    type: Types.SUBMIT_USER_REQUESTED,
    payload: data,
  };
}

export function saveSocialLinks(data) {
  return {
    type: Types.SAVE_SOCIAL_LINKS_REQUESTED,
    payload: data,
  };
}

export function addBulletin(data) {
  return {
    type: Types.ADD_BULLETIN_REQUESTED,
    payload: data,
  };
}

export function resetSchool() {
  return {
    type: Types.RESET_SCHOOL,
  };
}
